/* Native scrolling and deliberate playback: no scroll hijacking or autoplay. */
(() => {
  class RealReels extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.querySelectorAll('[data-reel-play]').forEach(button => {
        button.addEventListener('click', () => {
          const video = button.parentElement.querySelector('video');
          const source = video.querySelector('[data-src]');
          document.querySelectorAll('[data-reel-video]').forEach(other => { if (other !== video) other.pause(); });
          if (source) { source.src = source.dataset.src; source.removeAttribute('data-src'); video.load(); }
          video.play().then(() => { button.hidden = true; }).catch(() => { button.querySelector('span').textContent = 'Réessayer la lecture'; });
        }, { signal: this.abort.signal });
      });
      this.observer = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); }));
      this.querySelectorAll('video').forEach(video => this.observer.observe(video));
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.querySelectorAll('video').forEach(video => video.pause()); }
  }
  class ProductCompare extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const answers = {
        taste: 'HYNØX : le charbon actif agit sur le goût et les odeurs d’une eau déjà potable.',
        reminder: 'LUMØS : deux tapotements sur le bouchon activent le rappel d’hydratation. Un petit signal pour penser à boire.',
        uv: 'LUMØS : un cycle UV-C de 180 secondes dans la gourde fermée. Les UV-C ne retirent pas les contaminants chimiques.'
      };
      const update = () => {
        const key = this.querySelector('input:checked').value;
        this.querySelector('[data-compare-answer]').textContent = answers[key];
        this.querySelectorAll('[data-compare-row]').forEach(row => row.classList.toggle('is-relevant', row.dataset.compareRow === key));
      };
      this.addEventListener('change', update, { signal: this.abort.signal });
      update();
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  if (!customElements.get('hydros-real-reels')) customElements.define('hydros-real-reels', RealReels);
  if (!customElements.get('hydros-product-compare')) customElements.define('hydros-product-compare', ProductCompare);
})();
